<template>
  <base-row
    v-bind="$props"
    :selectable="true"
  >
    <td>
      <Link
        v-if="hasRoute"
        :href="showCustomerRoute"
        class="font-semibold text-blue-600 hover:text-blue-600"
      >
        {{ item.name ?? 'NA' }}
      </Link>
      <span
        v-else
        class="text-blue-600 hover:text-blue-600"
      >
        {{ item.name ?? 'NA' }}
      </span>
    </td>
    <td class="truncate max-w-xs">
      {{ item.email }}
    </td>
    <td>
      {{ item.phone }}
    </td>
    <td>
      {{ item.last_order_region }}
    </td>
    <td>
      {{ item.last_order_date ? _date(item.last_order_date) : '-' }}
    </td>
    <td>
      {{ _date(item.created_at) }}
    </td>
    <td>
      {{ item.orders_sum_total ? _dollars(item.orders_sum_total) : '-' }}
    </td>
    <td>
      {{ item.has_valid_medical ? 'Yes' : 'No' }}
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _date from '@/Filters/Date'
import _dollars from '@/Filters/Dollars'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a item. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a customer
     */
    showCustomerRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this customer has a valid URL to view a customer
     * @returns {boolean}
     */
    hasRoute() {
      return this.showCustomerRoute !== null
    }
  },
  methods: {
    _date,
    _dollars
  }
}
</script>
